// Angular
import { Injectable } from '@angular/core';

// Local file
import { FundingService } from './funding.service';

/** Business logic for the deposit PayNearMe component. */
@Injectable()
export class DepositPayNearMeService {

  constructor(
    private readonly fundingService: FundingService,
  ) {}

  /** Open the hosted PayNearMe deposit window for the current user. */
  openLink(): void {
    this.fundingService.openPayNearMe();
  }

}
